var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"64","cy":"64","r":"59","fill":"#4267B2","key":0}),React.createElement("path",{"d":"M72.252 44.5714H79V30H69.1465C58.6533 30 54 34.4824 54 43.0773V54.2857H44V64H54V98H69V64H77.9551L79 54.2857H69V48.3518C69 45.6434 69.5615 44.5714 72.252 44.5714Z","fill":"white","key":1})]);
}

FacebookIcon.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
